{
  "name": "@hanabi.rest/cli",
  "version": "0.3.2",
  "description": "CLI to download code, SQL, and dependencies for hanabi.rest applications.",
  "publishConfig": {
    "access": "public"
  },
  "license": "MIT",
  "type": "module",
  "exports": "./dist/index.js",
  "bin": "./dist/index.js",
  "repository": {
    "type": "git",
    "url": "https://github.com/hanabi-rest/cli"
  },
  "files": [
    "dist",
    "dist/templates/**/gitignore"
  ],
  "keywords": [
    "sqlite",
    "v0",
    "hono",
    "edge-computing",
    "cloudflare-workers"
  ],
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup && cp -r templates dist/ && rm dist/templates/index.ts",
    "typecheck": "tsc --noEmit",
    "clean": "rimraf dist",
    "start": "node dist/index.js",
    "test": "vitest run",
    "test:watch": "vitest -w",
    "coverage": "vitest --coverage",
    "release": "changeset version",
    "pub:beta": "pnpm build && pnpm publish --no-git-checks --access public --tag beta",
    "pub:next": "pnpm build && pnpm publish --no-git-checks --access public --tag next",
    "pub:release": "pnpm build && pnpm publish --access public"
  },
  "dependencies": {
    "@babel/parser": "^7.23.6",
    "@iarna/toml": "^2.2.5",
    "chalk": "^5.3.0",
    "commander": "^11.1.0",
    "cross-spawn": "^7.0.3",
    "fs-extra": "^11.2.0",
    "node-fetch": "^3.3.2",
    "package-json": "^9.0.0",
    "prompts": "^2.4.2",
    "ts-morph": "^21.0.1",
    "validate-npm-package-name": "^5.0.0",
    "xdg-app-paths": "^8.3.0"
  },
  "devDependencies": {
    "@biomejs/biome": "1.5.3",
    "@changesets/changelog-github": "^0.5.0",
    "@changesets/cli": "^2.27.1",
    "@types/cross-spawn": "^6.0.6",
    "@types/fs-extra": "^11.0.4",
    "@types/node": "^20",
    "@types/prompts": "^2.4.9",
    "@types/validate-npm-package-name": "^4.0.2",
    "dotenv": "^16.4.1",
    "rimraf": "^5.0.5",
    "tsup": "^8.0.1",
    "type-fest": "^4.10.1",
    "typescript": "^5.3.3",
    "vitest": "^1.2.2"
  }
}